import { CSSProperties } from "react";
import { getStyle } from "@app/shared/icons/utils";
import { IconStorage } from "@app/shared/icons/interfaces";

export const toggleOff: IconStorage = {
  svgCode: (color: string, pathStyle?: CSSProperties) => (
    <path
      d="M8.688-3.453A3.9 3.9 0 0 0 9-5q0-.809-.312-1.547a3.9 3.9 0 0 0-.86-1.281 3.9 3.9 0 0 0-1.281-.86A4 4 0 0 0 5-9q-.815 0-1.547.313-.737.315-1.281.859-.532.532-.86 1.281A3.9 3.9 0 0 0 1-5q-.002.815.313 1.547.326.737.859 1.281.544.532 1.281.86Q4.185-1 5-1q.81.002 1.547-.312c.5-.22.926-.504 1.281-.86q.544-.544.86-1.281m6 0A3.9 3.9 0 0 0 15-5q0-.809-.312-1.547a3.9 3.9 0 0 0-.86-1.281 3.9 3.9 0 0 0-1.281-.86A4 4 0 0 0 11-9H7.984a5 5 0 0 1 1.47 1.75Q9.997-6.2 10-5q-.001 1.207-.547 2.25A5 5 0 0 1 7.984-1H11q.81.002 1.547-.312.75-.328 1.281-.86.544-.544.86-1.281m.906-3.484Q16-6.013 16-5a4.8 4.8 0 0 1-.406 1.938A4.975 4.975 0 0 1 11 0H5Q3.981 0 3.063-.39A5.08 5.08 0 0 1 .39-3.063 4.9 4.9 0 0 1 0-5q0-1.013.39-1.937a4.975 4.975 0 0 1 2.672-2.656A4.8 4.8 0 0 1 5-10h6q1.012.001 1.938.406A4.8 4.8 0 0 1 14.53-8.53q.67.656 1.063 1.594m0 0"
      style={getStyle(color, pathStyle)}
      transform="translate(0 10)"
    />
  ),
  svgProps: {
    height: "10",
    width: "16",
  }
};

export const toggleOn: IconStorage = {
  svgCode: (color: string, pathStyle?: CSSProperties) => (
    <path
      d="M.39-3.062A4.9 4.9 0 0 1 0-5q0-1.013.39-1.937a4.975 4.975 0 0 1 2.672-2.656A4.8 4.8 0 0 1 5-10h6q1.012.001 1.938.406A4.8 4.8 0 0 1 14.53-8.53q.67.656 1.063 1.594Q16-6.013 16-5a4.8 4.8 0 0 1-.406 1.938A4.975 4.975 0 0 1 11 0H5Q3.981 0 3.063-.39A5.08 5.08 0 0 1 .39-3.063m9.063 1.75Q10.185-.998 11-1q.81.001 1.547-.312.75-.328 1.281-.86.544-.544.86-1.281A3.9 3.9 0 0 0 15-5q0-.809-.312-1.547a3.9 3.9 0 0 0-.86-1.281 3.9 3.9 0 0 0-1.281-.86A4 4 0 0 0 11-9q-.815 0-1.547.313-.737.315-1.281.859c-.356.355-.64.781-.86 1.281A3.9 3.9 0 0 0 7-5q-.002.815.313 1.547.326.737.859 1.281.544.532 1.281.86m0 0"
      style={getStyle(color, pathStyle)}
      transform="translate(0 10)"
    />
  ),
  svgProps: {
    height: "10",
    width: "16",
  }
};
